import React from 'react'
import SbEditable from 'storyblok-react'
import Link from '../atoms/Link'

const CategoriesBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="categories-block">
        <div className="categories-block-container">
          <div className="downloads-block-wrapper">
            <div className="categories-block-row">
              {block.categories?.length > 0 &&
                block.categories.map((item, index) => (
                  <div className="categories-block-cell" key={index}>
                    <Link className="categories-block-item" link={item.link}>
                      <div className="categories-block-item-icon">
                        {item.icon === 'chair' && (
                          <i class="far fa-chair-office"></i>
                        )}
                        {item.icon === 'tools' && <i class="far fa-tools"></i>}
                        {item.icon === 'info' && (
                          <i class="far fa-info-square"></i>
                        )}
                        {item.icon === 'question' && (
                          <i class="far fa-question-square"></i>
                        )}
                        {item.icon === 'cog' && <i class="far fa-cog"></i>}
                        {item.icon === 'truck' && <i class="far fa-truck"></i>}
                        {item.icon === 'clipboard' && (
                          <i class="far fa-clipboard-list-check"></i>
                        )}
                        {item.icon === 'pencil-ruler' && (
                          <i class="far fa-pencil-ruler"></i>
                        )}
                      </div>
                      {item.title?.length > 0 && (
                        <div className="categories-block-item-title">
                          {item.title}
                        </div>
                      )}
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default CategoriesBlock
